<script>
import { h } from 'vue'
export default {
  // See Login.vue for why `h` is imported rather than received as a render() argument.
  render () {
    return h('div')
  },
  created () {
    const bookId = this.$store.getters.currentUser ? this.$store.getters.currentUser.book_id : null
    this.$store.commit('deleteToken')
    this.$router.push({ name: 'LoggedOut', query: { i: bookId } })
  }
}
</script>
